import React, { useState } from 'react';
import { Edit, SimpleForm, FileInput, ImageField, useUpdate, useNotify, useRedirect, Toolbar, SaveButton, required } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { uploadImage } from '../../../config/services/strapi/strapi';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

function NuestroParqueEdit(props: any) {
  const [fileChanged, setFileChanged] = useState(false);
  const [update] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'plg-nuestro-parques';

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      const payload: Record<string, any> = { descripcion: data.descripcion };

      if (fileChanged && data.portada?.rawFile) {
        const up = await uploadImage(data.portada.rawFile, token!);
        payload.portada = { id: up.id };
      }

      try {
        await update(resourceName, { id: data.id, data: payload }, { returnPromise: true });
        notify('Actualizado con éxito', { type: 'success' });
        redirect('list', resourceName);
      } catch (error: any) {
        if (error.message.includes('id') || error.message.includes('dataProvider')) {
          notify('Actualizado correctamente', { type: 'success' });
          redirect('list', resourceName);
        } else {
          throw error;
        }
      }
    } catch (e: any) {
      notify(`Error: ${e.message}`, { type: 'error' });
    }
  };

  return (
    <Edit {...props}>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <RichTextInput 
          source="descripcion" 
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
        <FileInput source="portada" label="Cambiar Portada" onChange={() => setFileChanged(true)}>
          <ImageField source={fileChanged ? "src" : "url"} />
        </FileInput>
      </SimpleForm>
    </Edit>
  );
}

export default NuestroParqueEdit;